import { IExternalResumesFilters } from './../../types/Filters/ExternalResumesFilters';
import { getQueryFromObject } from 'network/utils';
import { API } from 'aws-amplify';
import awsUtils from 'utils/awsUtils';

const apiName = awsUtils.getAPIName();

const getAll = async (filters: IExternalResumesFilters = {}) => {
  const authHeader = await awsUtils.getAuthHeader();
  const query = getQueryFromObject(filters)
  const path = `/external/external_resume/?${query}`;
  const myInit = {
    headers: { ...authHeader, },
  };

  const result = await API.get(apiName, path, myInit);
  return result;
};

const getOne = async (filters: IExternalResumesFilters = {}) => {
  return (await getAll(filters))?.data[0];
};


const ExternalResumesApi = { getAll, getOne };

export default ExternalResumesApi;